<template>
  <b-modal
    id="modal-notif-action"
    ref="modal-notif-action"
    title=""
    size="lg"
    centered
    hide-header
    modal-class="mc-modal-notif-action"
  >
    <div v-if="notifAction === 'pop_up_image'" class="mc-modal-notif-action__wrapper">
      <img :src="notifData['data']" :alt="notifData['title']" />
      <i class="mc-fa icon-outline_close" @click="hideModalNotifAction"></i>
    </div>
    <div v-else-if="notifAction === 'pop_up_video'" class="mc-modal-notif-action__wrapper">
      <iframe :title="notifData['title']" :src="notifData['data']" allowfullscreen />
    </div>
    <div v-else-if="notifAction === 'carousel_image'" class="mc-modal-notif-action__wrapper">
      <div id="carouselNotif" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button
            v-for="(_, index) in notifData"
            :key="index"
            type="button"
            data-bs-target="#carouselNotif"
            :data-bs-slide-to="index"
            :class="{ active: index === currentCarouselIndex }"
            :aria-current="index === currentCarouselIndex"
          ></button>
        </div>
        <div class="carousel-inner">
          <div
            v-for="(_, index) in notifData"
            :key="index"
            class="carousel-item"
            :class="{ active: index === currentCarouselIndex }"
          >
            <img
              :src="notifData[currentCarouselIndex].data"
              class="d-block w-100"
              :alt="`Carousel Notif ${index}`"
            />
          </div>
        </div>
        <button
          class="carousel-control-prev carousel-button"
          type="button"
          data-bs-target="#carouselNotif"
          data-bs-slide="prev"
          @click="carouselPrevious"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next carousel-button"
          type="button"
          data-bs-target="#carouselNotif"
          data-bs-slide="next"
          @click="carouselNext"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
    <template #modal-footer>
      <div v-if="notifAction !== 'carousel_image'" class="w-100 text-center">
        <h3>{{ notifData.title }}</h3>
      </div>
      <div v-if="notifAction !== 'carousel_image'" class="w-100 text-center">
        <p>{{ notifData.description }}</p>
      </div>
      <div v-else-if="Array.isArray(notifData)" class="w-100 text-center">
        <!-- Handle case where notifData is an array (carousel_image) -->
        <div v-if="currentCarouselIndex >= 0 && currentCarouselIndex < notifData.length">
          <h3>{{ notifData[currentCarouselIndex].title }}</h3>
          <p>{{ notifData[currentCarouselIndex].description }}</p>
        </div>
      </div>
      <b-button center variant="primary" @click="hideModalNotifAction">{{
        $t('navbar.notif.understand')
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    notifAction: {
      type: String,
      required: true,
    },
    notifData: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      currentCarouselIndex: 0,
    }
  },
  methods: {
    hideModalNotifAction() {
      this.$bvModal.hide('modal-notif-action')
    },

    carouselPrevious() {
      this.currentCarouselIndex =
        (this.currentCarouselIndex - 1 + this.notifData.length) % this.notifData.length
    },

    carouselNext() {
      this.currentCarouselIndex = (this.currentCarouselIndex + 1) % this.notifData.length
    },
  },
}
</script>
